import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

import { AutoUnsub } from 'src/app/core/decorators/auto-unsub.decorator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
})
@AutoUnsub()
export class PaginationComponent implements OnInit {
  @Input() public currentPage = 1;
  @Input() public totalPages = 1;
  @Input() public rangePages = 3;
  @Input() public itemsPerPage = 50;
  public itemsRanges = [10, 20, 50, 100];

  constructor(private route: Router, private router: ActivatedRoute) {}

  ngOnInit(): void {
    //Do nothing
  }

  counterPages(): number[] {
    const min =
      this.currentPage - this.rangePages > 1
        ? this.currentPage - this.rangePages
        : 1;
    const max =
      this.currentPage + this.rangePages < this.totalPages
        ? this.currentPage + this.rangePages
        : this.totalPages;

    return new Array(max - min + 1).fill(1).map((_, i) => min + i);
  }

  changeItemsPerPage(res: any): void {
    this.route.navigate(['./'], {
      relativeTo: this.router,
      queryParamsHandling: 'merge',
      queryParams: {
        itemsPerPage: this.itemsPerPage,
      },
    });
  }
}
